import * as React from "react";
import { showUsageInstruction } from "../actions";
import { connect, PureComponentEx, translate } from "./ComponentEx";
import { IconButton } from "./TooltipControls";
class Usage extends PureComponentEx {
    render() {
        const { t, persistent, show, opaque } = this.props;
        const classes = ["usage-instructions"];
        if (!opaque) {
            classes.push("usage-instructions-transparent");
        }
        classes.push(show ? "usage-instructions-show" : "usage-instructions-hide");
        if (this.props.className !== undefined) {
            classes.push(...this.props.className.split(" "));
        }
        if (show) {
            return (React.createElement("div", { className: classes.join(" ") },
                React.createElement("div", { className: "usage-instructions-content" },
                    React.createElement("div", null, this.props.children)),
                React.createElement(IconButton, { className: "close-button", id: "btn-close-login", onClick: this.props.onHide, tooltip: t("Close"), icon: "close" })));
        }
        else if (persistent) {
            return (React.createElement("div", { className: classes.join(" "), onClick: this.props.onShow }, t("Show Usage Instructions")));
        }
        else {
            return null;
        }
    }
}
function mapStateToProps(state, ownProps) {
    return {
        // Defensive check: interface.usage might not be initialized during hydration
        show: state.settings?.interface?.usage?.[ownProps.infoId] !== false,
    };
}
function mapDispatchToProps(dispatch, ownProps) {
    const { infoId } = ownProps;
    return {
        onShow: () => {
            dispatch(showUsageInstruction(infoId, true));
        },
        onHide: () => {
            dispatch(showUsageInstruction(infoId, false));
        },
    };
}
export default translate(["common"])(connect(mapStateToProps, mapDispatchToProps)(Usage));
